/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, Configs, Ducks, EpgUtils } from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { select } from 'redux-saga/effects';

export function* filterInvalidEpgPrograms(assets: Asset[]): SagaIterator<Asset[]> {
  const configs: Configs | undefined = yield select(Ducks.Dms.Selectors.getDmsConfigs);
  if (configs) {
    return EpgUtils.filterInvalidEpgPrograms(assets, configs.epgBackwardDays, configs.epgForwardDays);
  }
  return assets;
}
